'use strict';var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}} // Copyright 2015-2017 Parity Technologies (UK) Ltd.
// This file is part of Parity.

// Parity is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.

// Parity is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.

// You should have received a copy of the GNU General Public License
// along with Parity.  If not, see <http://www.gnu.org/licenses/>.

var TYPES = require('./types');var

ParamType = function () {
  function ParamType(type) {var subtype = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;var indexed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;_classCallCheck(this, ParamType);
    ParamType.validateType(type);

    this._type = type;
    this._subtype = subtype;
    this._length = length;
    this._indexed = indexed;
  }_createClass(ParamType, [{ key: 'type', get: function get()

    {
      return this._type;
    } }, { key: 'subtype', get: function get()

    {
      return this._subtype;
    } }, { key: 'length', get: function get()

    {
      return this._length;
    } }, { key: 'indexed', get: function get()

    {
      return this._indexed;
    } }]);return ParamType;}();


ParamType.validateType = function (type) {
  if (TYPES.filter(function (_type) {return type === _type;}).length) {
    return true;
  }

  throw new Error('Invalid type ' + type + ' received for ParamType');
};

module.exports = ParamType;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@parity/abi/lib/spec/paramType/paramType.js
// module id = 111
// module chunks = 0